export default __webpack_public_path__ + "static/media/eyeHide.bd79fd9e.svg";